import React from 'react';
import { Reveal } from './ui/Reveal';
import { pains } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="familiar" className="border-y-2 border-coral/30 bg-carbon-soft" data-id="element-124" data-mp="2ltmhrt8r1rll">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-7" data-id="element-125" data-mp="30isjbnv27twn">
        <Reveal className="text-center" data-id="element-126" data-mp="2vq7ruszmlswa">
          <h2 id="familiar" className="font-display text-2xl uppercase leading-none tracking-wide text-coral sm:text-4xl" data-id="element-127" data-mp="2voefqy68uggw">
            ¿Te suena familiar?
          </h2>
          <p className="mt-1 text-[0.82rem] font-bold text-cream sm:text-base" data-id="element-128" data-mp="35idinze5649w">
            Quieres mejorar tus entrenamientos de glúteos y piernas, pero no
            sabes exactamente qué hacer.
          </p>
          <p className="mx-auto mt-1 max-w-2xl text-[0.78rem] leading-snug text-muted sm:text-sm" data-id="element-129" data-mp="1p212qgt3mec8">
            Si estás comenzando o llevas tiempo entrenando sin una estructura
            clara, probablemente conozcas alguna de estas situaciones:
          </p>
        </Reveal>

        <ul className="mt-3.5 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-130" data-mp="jb0nfb52h28z">
          {pains.map((pain, i) => <Reveal key={pain.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-nude/20 bg-carbon p-3.5" data-id="element-131" data-mp="o9tzr08man7k" data-mpi={i}>
              <h3 className="font-display text-base uppercase leading-tight tracking-wide text-coral sm:text-lg" data-id="element-132" data-mp="123v3y9ic92fb">
                {pain.title}
              </h3>
              <p className="mt-1 text-[0.78rem] leading-snug text-beige sm:text-[0.82rem]" data-id="element-133" data-mp="170v0nttasstr">
                {pain.desc}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}